import React from 'react';
import AurAcknowlegment from '../../../common/aur-acknowledgement/AurAcknowledgement';
import {Link} from 'react-router-dom';

const Acknowledgement: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>Acknowledgement</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '8px'}}>
          <AurAcknowlegment
            labelSubText="Indicate that you understand that uploading evidence source material is likely a billable event by typing “I understand” in the field below:"
            showCheckbox={false}
            labelHeading="Acknowledgement"
          />

          <AurAcknowlegment
            labelCheckbox={
              'All of the information of the billing agreement displayed above is exactly accurate.\nThis new project will use all of these same details.'
            }
            labelSubText="By typing “I understand” I acknowledge this project will be created and that it is a billable event."
            showCheckbox={true}
          />

          <AurAcknowlegment
            labelSubText="Indicate that you understand that uploading evidence source material is likely a billable event by typing “I understand” in the field below:"
            showCheckbox={false}
            showIntiateButton={true}
            initateBtnEnabled={true}
            labelHeading="Acknowledgement"
          />
        </div>
      </div>
    </>
  );
};

export default Acknowledgement;
